import type { MeResponse } from "@ondo/shared";

import { useClaimStudioController } from "./useClaimStudioController.ts";
import { CLAIM_STUDIO_COPY } from "./workspace.constants.ts";
import "./workspace.css";

type Props = {
  replaceMe: (me: MeResponse) => void;
};

/**
 * "A studio is waiting for you" — OND-7.
 *
 * Renders what the controller decided and nothing more. Hidden entirely when no
 * studio waits at the caller's address, which is the answer for almost
 * everybody, so the two screens that mount it — the verifier's inbox and the
 * workspace chooser — pay nothing for carrying it.
 */
export function ClaimStudioBanner({ replaceMe }: Props) {
  const { view, claim } = useClaimStudioController({ replaceMe });

  if (view.kind === "hidden") return null;

  return (
    <section className="workspace__claim-studio" aria-labelledby="claim-studio-eyebrow">
      <p className="workspace__claim-studio-eyebrow" id="claim-studio-eyebrow">
        {view.note.eyebrow}
      </p>
      <p className="workspace__note">{view.note.sentence}</p>

      {view.error ? (
        <p className="workspace__error" role="alert">
          {view.error}
        </p>
      ) : null}

      <div className="workspace__claim-studio-actions">
        <button className="workspace__apply" type="button" disabled={view.busy} onClick={claim}>
          {view.busy ? CLAIM_STUDIO_COPY.claiming : CLAIM_STUDIO_COPY.claim}
        </button>
      </div>
    </section>
  );
}
